import React from 'react';
import styles from '../styles/lead/LoginPromo.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons';

const LoginPromo = (props) => {
    const {goToLogin} = props;
    return (
        <div className={`${styles.root}`}>      
            <p className="mb-0 heading3 font-weight-bold">
                <FontAwesomeIcon icon={faUser} height="16" width="16" size="1x" className="green me-2"/>
                Ai deja cont?
                </p>
            <p className="mb-1">  
                <span className={styles.link} onClick={goToLogin}>Conectează-te</span> și formularul va fi precompletat cu datele din profil.
            </p>  
        </div>
    )
}

export default LoginPromo;